
/**
 * GetIncorporacaoImovelByIdUseCase
 */
import { IGetIncorporacaoImovelByIdUseCase } from "../../../presentation/useCases/read/get_incorporacao_imovel_by_id_use_case";
import { IncorporacaoImovel } from "../../models/incorporacao_imovel";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";


export class GetIncorporacaoImovelByIdUseCase implements IGetIncorporacaoImovelByIdUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async getIncorporacaoImovelById(
    idIncorporacaoImovel: number,
  ): Promise<IncorporacaoImovel> {
    return await this.repository.getIncorporacaoImovelById(idIncorporacaoImovel);
  }
}
